export default __webpack_public_path__ + "static/media/close.15f1023c.png";